module.exports = __webpack_public_path__ + "img/menuIcon19.81cc8608.png";